/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiStoreStatsResponseFromJSON(json) {
    return ApiStoreStatsResponseFromJSONTyped(json, false);
}
export function ApiStoreStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customersCount': !exists(json, 'customersCount') ? undefined : json['customersCount'],
        'productsCount': !exists(json, 'productsCount') ? undefined : json['productsCount'],
        'transactionsCount': !exists(json, 'transactionsCount') ? undefined : json['transactionsCount'],
    };
}
export function ApiStoreStatsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customersCount': value.customersCount,
        'productsCount': value.productsCount,
        'transactionsCount': value.transactionsCount,
    };
}
